import React from 'react';

const SelectCidade = ({ SalvarCidade, cidades, cod_cidade }) => {
   
    return (
        <select name="cidades" id="cidades" onChange={SalvarCidade} value={cod_cidade || "000000"}>
            <option value="000000">Cidade</option>
            {cidades.map(c => (
                <option key={c.cod_cidade} value={c.cod_cidade}>
                    {c.cidade} - {c.uf}
                </option>
            ))}
        </select>
    );
};

export default SelectCidade;